export default (hit, isInit) => {
  let date = new Date(hit.date.date)
  date = `${date.getDate().toString().padStart(2, '0')}.${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getFullYear()}`

  return `
  <a href="${hit.path}" class="card-actu w-full">
    <div class="card-actu__top relative">
        <img src="https://res.cloudinary.com/dl8lvr6ag/image/upload/c_fill,f_auto,q_auto,w_384,h_210/${hit.picture.singleMedia.publicId}" alt="${hit.title}" class="object-fit-image" />
    </div>

    <div class="card-actu__bottom text-indigo-blue">
        <div class="card-actu__headline mb-5">
            <span class="mr-4">${date}</span>
            <span class="opacity-50">${hit.tag}</span>
        </div>

        <p class="title title--5 title--semibold text-sea-blue mb-2">${hit.title}</p>

        ${hit.description
          ? `<div class="card-actu__txt">${hit.description}</div>`
          : ''
        }
    </div>
  </a>
  `
}
